// sp-buybar.js — barre d'achat collante de la fiche. Aucune dépendance.
// Affichage : le bouton principal est sorti de l'écran PAR LE HAUT (jamais avant de
// l'avoir atteint). Contenu : recopie du prix et du format que Dawn vient de rendre.
(() => {
  const bar = document.querySelector('[data-sp-buybar]');
  if (!bar) return;
  const sid = bar.dataset.section;
  const main = document.getElementById(`ProductSubmitButton-${sid}`);
  const priceBox = document.getElementById(`price-${sid}`);
  const btn = bar.querySelector('[data-sp-buybar-btn]');
  if (!main) return;

  // Visible dès le chargement (le bouton est sous la ligne de flottaison), retirée dès
  // que le bouton principal entre à l'écran : une seule instance de prix et d'achat à la fois.
  new IntersectionObserver(([e]) => {
    const shown = !e.isIntersecting;
    bar.toggleAttribute('data-shown', shown);
    bar.setAttribute('aria-hidden', String(!shown));
    btn.tabIndex = shown ? 0 : -1;
  }, { threshold: 0 }).observe(main);

  const sync = () => {
    const p = priceBox && priceBox.querySelector('.price__sale:not(.hidden) .price-item--sale, .price-item--regular');
    if (p) bar.querySelector('[data-sp-buybar-price]').textContent = p.textContent.trim();
    // Une pastille cochée par option : le format, puis le cadre s'il y en a un (« A2 · 42 × 59,4 cm · Noir »).
    // Le libellé est dans .sp-pill-label (chantier 62) ; childNodes[0] était un blanc, et la
    // barre n'affichait que les cotes.
    // Options masquées exclues (l'option « Product » de Gelato), doublons retirés : pendant
    // le remplacement du sélecteur par Dawn, l'ancien et le nouveau coexistent un instant.
    const checked = [...new Set([...document.querySelectorAll(`#variant-selects-${sid} fieldset:not([hidden]) input:checked + label`)]
      .map((l) => (l.querySelector('.sp-pill-label') || l).textContent.trim()))];
    const dim = priceBox && priceBox.querySelector('.sp-dim');
    bar.querySelector('[data-sp-buybar-format]').textContent =
      [checked[0], dim && dim.textContent.split('·')[0].trim(), ...checked.slice(1)]
        .filter(Boolean).join(' · ');
    btn.disabled = main.disabled;
  };
  sync();
  if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true });
  new MutationObserver(sync).observe(main, { attributes: true, attributeFilter: ['disabled'] });
})();
